import { useCallback, useEffect, useState } from "react";

import { api } from "../api/client";


export function useAuth() {
  const [token, setToken] = useState(() => localStorage.getItem("auth_token") || "");
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("auth_user");
    return raw ? JSON.parse(raw) : null;
  });
  const isAuthed = !!user;

  const rehydrate = useCallback(() => {
    const t = localStorage.getItem("auth_token") || "";
    const raw = localStorage.getItem("auth_user");
    setToken(t);
    setUser(raw ? JSON.parse(raw) : null);
  }, []);

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === "auth_token" || e.key === "auth_user") rehydrate();
    };
    const onAuthChanged = () => rehydrate();
    window.addEventListener("storage", onStorage);
    window.addEventListener("auth:changed", onAuthChanged);
    return () => {
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("auth:changed", onAuthChanged);
    };
  }, [rehydrate]);

  function saveAuth(t, u) {
    localStorage.setItem("auth_token", t);
    localStorage.setItem("auth_user", JSON.stringify(u));
    setToken(t);
    setUser(u);
    try { window.dispatchEvent(new Event("auth:changed")); } catch (err) { /* noop */ }
  }

  function clearAuth() {
    // Best-effort server-side revocation. Fire-and-forget; never block sign-out.
    try {
      api.post("/auth/logout").catch(() => {});
    } catch (err) { /* noop */ }
    localStorage.removeItem("auth_token");
    localStorage.removeItem("auth_user");
    setToken("");
    setUser(null);
    try { window.dispatchEvent(new Event("auth:changed")); } catch (err) { /* noop */ }
  }

  return { token, user, isAuthed, saveAuth, clearAuth };
}
